<template>
  <div
    :class="{ ViewPageDefault_bare: !hero.image }"
    class="ViewPageDefault"
  >
    <HeroSecondary
      v-if="hero && hero.image"
      v-bind="hero"
    />
    <div class="ViewPageDefault__container">
      <div
        class="ViewPageDefault__column"
        v-html="html"
      />
    </div>
  </div>
</template>

<script>
  import HeroSecondary from './HeroSecondary';

  export default {
    components: {
      HeroSecondary,
    },
    props: {
      hero: {
        type: Object,
        default: null,
      },
      html: {
        type: String,
        default: '',
      },
    },
    cleanProps({ acf: { hero }, content: { rendered: html } }) {
      return { hero, html };
    },
  };
</script>

<style lang="scss">
.ViewPageDefault_bare {
  border-top: 115px solid color(slate);

  @include breakpoint(tablet) {
    border-top-width: 134px;
  }
}

.ViewPageDefault__container {
  @include container;

  margin-top: (spacing(base-gamma) / 2) + spacing(base-delta);
  margin-bottom: (spacing(base-gamma) / 2) + spacing(base-delta);

  @include breakpoint(phablet) {
    margin-top: spacing(base-eta);
    margin-bottom: spacing(base-eta);
    padding-right: percentage(1 / 12);
    padding-left: percentage(1 / 12);
  }
}

.ViewPageDefault__column {
  @include column;
}

h1 {
  .ViewPageDefault & {
    font-family: font-family(sans-serif);
    font-weight: font-weight(extra-bold);
    font-size: 5.2rem;
    letter-spacing: (3em / 52);
    line-height: (55 / 52);
    text-transform: uppercase;
    color: color(red);
  }
}

h2 {
  .ViewPageDefault & {
    font-family: font-family(serif);
    font-weight: font-weight(bold);
    font-size: 3.5rem;
    line-height: (45 / 35);
    letter-spacing: (0.15em / 35);
    color: color(red);
  }
}

h3 {
  .ViewPageDefault & {
    font-family: font-family(sans-serif);
    font-weight: font-weight(extra-bold);
    font-size: 2.4rem;
    letter-spacing: (1em / 24);
    line-height: (30 / 24);
    text-transform: uppercase;
    color: color(red);
  }
}

h4 {
  .ViewPageDefault & {
    font-family: font-family(serif);
    font-weight: font-weight(bold);
    font-size: 2.7rem;
    letter-spacing: (0.1em / 27);
    line-height: (32 / 27);
    color: color(red);
  }
}

img {
  .ViewPageDefault & {
    height: auto;
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .ViewPageDefault &.alignleft {
    float: left;
    margin-right: 5rem;
  }

  .ViewPageDefault &.aligncenter {
    margin-right: auto;
    margin-left: auto;
  }

  .ViewPageDefault &.alignright {
    float: right;
    margin-left: 5rem;
  }
}

a {
  .ViewPageDefault & {
    color: color(red);

    &:hover {
      text-decoration: underline;
    }
  }
}

.label {
  .ViewPageDefault & {
    color: color(bronze);
    font-family: font-family(sans-serif);
    font-weight: font-weight(extra-bold);
    font-size: 1.1rem;
    letter-spacing: (1em / 11);
    line-height: (18 / 11);
    text-transform: uppercase;
  }
}

h1,
h2,
h3,
h4,
.label {
  .ViewPageDefault p + & {
    margin-top: 5rem;
  }

  .ViewPageDefault .label + & {
    margin-top: 1rem;
  }
}

p,
ol,
ul {
  .ViewPageDefault & {
    font-family: font-family(sans-serif);
    font-weight: font-weight(regular);
    font-size: 1.4rem;
    letter-spacing: (0.4em / 14);
    line-height: (23 / 14);
  }

  .ViewPageDefault h1 + & {
    margin-top: 5rem;

    @include breakpoint(phablet) {
      margin-top: 9rem;
    }
  }

  .ViewPageDefault h2 + &,
  .ViewPageDefault h3 + &,
  .ViewPageDefault h4 + &,
  .ViewPageDefault & + & {
    margin-top: 2.1rem;
  }
}

blockquote {
  margin: 5rem;

  .ViewPageDefault & {
    & p {
      font-family: font-family(sans-serif);
      font-weight: font-weight(extra-bold);
      font-size: 1.9rem;
      letter-spacing: (1.8em / 19);
      line-height: (38 / 19);
      text-transform: uppercase;
      color: color(bronze);
    }
  }
}

ol {
  .ViewPageDefault & {
    counter-reset: li;
  }
}

li {
  .ViewPageDefault & {
    position: relative;
    margin-left: spacing(base-delta);
    padding-left: spacing(base-beta);
  }

  .ViewPageDefault &::before {
    position: absolute;
    right: calc(100% + 10px);
    display: block;
    color: color(bronze);
  }

  .ViewPageDefault & + &,
  .ViewPageDefault & > ol > &,
  .ViewPageDefault & > ul > & {
    margin-top: 1rem;
  }

  .ViewPageDefault ol &::before {
    counter-increment: li;
    content: counter(li) '.';
  }

  .ViewPageDefault ul &::before {
    content: '▪';
  }
}
</style>
